import gsap from "gsap";

import { mixAnimChars } from "../utils/variables";

declare global {
    interface HTMLElement {
        scramble?: gsap.core.Timeline;
    }
}

export function scrambleTextAnim(el: HTMLElement, text: string, customWidth: number | string | null = null) {
    const width = el.offsetWidth;

    let delay = 0.1;

    if (el.tagName.toLowerCase() === "h1") {
        el.innerHTML = "&nbsp;";
        delay = 0.5;
    }

    const animKey = "scramble";
    const currentAnimation = el[animKey];

    if (currentAnimation && currentAnimation.isActive()) return;

    const tl = gsap
        .timeline({
            onStart: () => {
                el[animKey] = tl;
            },
            onComplete: () => {
                delete el[animKey];
            },
        })
        .set(el, { width: customWidth ? customWidth : width })
        .to(el, {
            duration: 0.4,
            delay: delay,
            scrambleText: {
                text: text,
                speed: 0.1,
                chars: `${text}${mixAnimChars}`,
                tweenLength: false,
                revealDelay: 0.1,
            },
            onComplete: () => {
                el.style.width = "";
            },
        });
}
